import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RaiseRequestService {
  private baseUrl = environment.baseUrl;

  constructor(private http: HttpClient) { }

  getCategories(obj: { account_group_id: number | string }): Observable<any> {
    return this.http.post(`${this.baseUrl}/category_dropdown`, obj);
  }

  getSubCategories(obj: { issue_category_id: number | string; account_id?: number | string }): Observable<any> {
    return this.http.post(`${this.baseUrl}/subcategory_dropdown`, obj);
  }

  getBlockDropdown(accountId: number | string): Observable<any> {
    return this.http.post(`${this.baseUrl}/block_dropdown`, { account_id: accountId });
  }

  getUnitTypeDropdown(accountId: number | string): Observable<any> {
    return this.http.post(`${this.baseUrl}/project_unit_type_dropdown`, { account_id: accountId });
  }

  getFloorDropdown(
    accountId: number | string,
    blockId: number | string
  ): Observable<any> {
    return this.http.post(`${this.baseUrl}/fetch_floor_dropdown`, {
      account_id: accountId,
      block_id: blockId,
    });
  }

  getUnitDropdown(payload: {
    account_id: number | string;
    block_id?: number | string | null;
    phase_id?: number | null;
    floor_id?: number | string | null;
    unit_type?: string | null;
  }): Observable<any> {
    return this.http.post(`${this.baseUrl}/unit_dropdown`, {
      account_id: payload.account_id,
      block_id: payload.block_id ?? null,
      phase_id: payload.phase_id ?? null,
      floor_id: payload.floor_id ?? null,
      unit_type: payload.unit_type ?? null,
    });
  }

  submitIssue(formData: FormData): Observable<any> {
    return this.http.post(`${this.baseUrl}/report_issue`, formData);
  }

  fetchAllIssues(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}/fetch_issues_by_filter`, payload);
  }

  fetchMyIssues(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}/fetch_my_issues`, payload);
  }
}
